import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { getThread } from '@/features/internal/patient-messaging/apis/patientMessagingApi'
import { LineThreadDetail } from '@/features/internal/patient-messaging/types/patientMessaging'

export const useThreadQuery = (threadId: string | null) => {
  const query = useQuery({
    queryKey: queryKeys.patientMessaging.thread(threadId ?? ''),
    queryFn: async (): Promise<LineThreadDetail> => {
      if (!threadId) {
        throw new Error('Thread ID is required')
      }
      return await getThread(threadId)
    },
    enabled: !!threadId,
    staleTime: 0,
    // 一覧と同じ周期で取り直す (design-book list の polling 規約)。開いている間は back が既読を進める
    refetchInterval: 30_000,
  })

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    isFetching: query.isFetching,
    dataUpdatedAt: query.dataUpdatedAt,
  }
}
